import {getAxiosInstance, requestConfig} from "../../http-common";
import { CreateGroupCodeRequest } from "../../models/groupcodes/CreateGroupCodeRequest";
import { DeleteGroupCodeRequest } from "../../models/groupcodes/DeleteGroupCodeRequest";
import { GroupCode } from "../../models/groupcodes/GroupCode";
import { UpdateGroupCodeRequest } from "../../models/groupcodes/UpdateGroupCodeRequest";

const RESOURCE_NAME = "groupcodes";

const getAll = () => {
  const http = getAxiosInstance();
  return http.get<GroupCode[]>(`${RESOURCE_NAME}/getAllGroupCodes`, requestConfig());
};

const create = (model : CreateGroupCodeRequest) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/CreateGroupCode`, model, requestConfig());
}
const update = (model : UpdateGroupCodeRequest) => {
  const http = getAxiosInstance();
  return http.put(`${RESOURCE_NAME}/UpdateGroupCode/${model.id}`, model, requestConfig());
}

const remove = (model: DeleteGroupCodeRequest) => {
  const http = getAxiosInstance();
  return http.delete(`${RESOURCE_NAME}/DeleteGroupCode/${model.id}`, requestConfig());
}

const GroupCodesService = {
  getAll,
  create,
  update,
  remove,
};
export default GroupCodesService;
